import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "../css/currencyRates.css";
import getReq from "../interface/getRequestinterface";
import { getRequest } from "../request";
import Loading from "./loading";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import { RQUseQuery } from "../components/RQUseQueryHook.ts";

interface currencyVolumes {
  count: number;
  key: string;
  volume: number;
}
interface dataRates {
  totalOrders: number;
  totalRialVolume: number;
  currencyVolumes: currencyVolumes[];
  credit: {
    creditAmount: number;
    creditInUse: number;
    currency: string;
    serverDateTime: string;
    shamsiInt: number;
  };
  companyCount: number;
  companies: string[];
}
function CurrencyRates() {
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const [rates, setRates] = useState<dataRates>({
    totalOrders: 0,
    totalRialVolume: 0,
    currencyVolumes: [],
    credit: {
      creditAmount: 0,
      creditInUse: 0,
      currency: "",
      serverDateTime: "",
      shamsiInt: 0,
    },
    companyCount: 0,
    companies: [],
  });

  const onSuccess = (data) => {
    setRates(data.data);
    setTimeout(() => {
      setIsLoading(true);
    }, 2000);
  };
  const onError = (err) => {
    console.log(err);
  };
  RQUseQuery(
    `${process.env.REACT_APP_BASE_URL}/Report/ExchangeInfo`,
    "exchangeInfo",
    true,
    false,
    onSuccess,
    onError
  );

  const currencyChecker = (value: number) => {
    if (value?.toString().length > 9) {
      return (
        (+(
          +value?.toString().slice(0, value?.toString().length - 8) / 10
        ).toFixed(1)).toLocaleString() + " میلیارد "
      );
    } else if (value?.toString().length > 6) {
      return (
        (+value
          ?.toString()
          .slice(0, value?.toString().length - 6)).toLocaleString() + " میلیون "
      );
    } else {
      return value?.toLocaleString();
    }
  };
  const getCountry = (flag) => {
    switch (flag) {
      case "EUR ":
        return "eu";
      case "CNY ":
        return "cn";
      case "USD ":
        return "um";
      case "AED ":
        return "ae";
      case "INR ":
        return "in";
      case "GBP ":
        return "gb";
      case "RUB ":
        return "ru";
      case "KRW ":
        return "kr";
      case "TRY ":
        return "tr";
      case "ZAR ":
        return "za";
      default:
        break;
    }
  };
  return (
    <div className="background">
      {isLoading ? (
        <div className="container ">
          <div>
            <div
              style={{
                width: "100%",
                justifyContent: "center",
                display: "flex",
                marginTop: "2.5rem",
              }}
            >
              <div className="currencyRatesHeader">
                <div className="firstElementTag">
                  <span style={{ color: "#efefef", textAlign: "center" }}>
                    تعداد حواله{" "}
                  </span>
                  <span className="secondElementTag">
                    <b>{currencyChecker(rates?.totalOrders)}</b>
                  </span>
                </div>
                <div className="firstElementTag">
                  <span style={{ color: "#efefef" }}>
                    حجم حواله ها به ریال{" "}
                  </span>
                  <span className="secondElementTag">
                    <b>{currencyChecker(rates?.totalRialVolume)}</b>
                  </span>
                </div>
              </div>
            </div>
            <div className="mainCredits">
              <div className="credits">
                <span className="creditsHeader">تعهدات (به یورو)</span>
                <div style={{ width: "100%" }}>
                  <div className="creditBody">
                    <div>
                      <span className="creditItem">حجم تعهدات صرافی: </span>
                      <span className="creditItem">
                        <b>{currencyChecker(rates?.credit?.creditInUse)}</b>
                      </span>
                    </div>
                    <div>
                      <span className="creditItem">سقف تعهد صرافی: </span>
                      <span className="creditItem">
                        <b>{currencyChecker(rates?.credit?.creditAmount)}</b>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <TableContainer
                component={Paper}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  width: "fit-content",
                }}
              >
                <Table sx={{ width: "65rem" }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell className="ratesTh" align="right">
                        نوع ارز
                      </TableCell>
                      <TableCell className="ratesTh" align="right">
                        تعداد حواله
                      </TableCell>
                      <TableCell className="ratesTh" align="right">
                        حجم حواله
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rates?.currencyVolumes?.map((row, index) => (
                      <TableRow
                        className="ratesTr"
                        key={index}
                        sx={{ "&:last-child , &:last-child": { border: 0 } }}
                      >
                        <TableCell
                          className="ratesTd"
                          scope="row"
                          align="right"
                        >
                          <span
                            className={`fi fi-${getCountry(
                              row.key.split("-")[0]
                            )}`}
                          ></span>{" "}
                          {row.key}
                        </TableCell>
                        <TableCell className="ratesTd" align="right">
                          {row.count.toLocaleString()}
                        </TableCell>
                        <TableCell className="ratesTd" align="right">
                          {currencyChecker(row.volume)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "5rem",
                marginBottom: "2rem",
                boxShadow: "0px 0px 4px 2px #bdbdbd",
                alignItems: "center",
                height: "3rem",
                borderRadius: "3px",
              }}
            >
              تعداد شرکت های همکار: {rates?.companyCount?.toLocaleString()}
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            width: "100vw",
            height: "calc( 100vh - 64px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loading type="cylon" color="#000" />
        </div>
      )}
    </div>
  );
}

export default CurrencyRates;
